<template>
    <div class="body-panel dataContent">
        <template v-if="report != null">
            <div class="body-panel-control separator">
                <div class="control-block-left">
                    <div class="flex">
                        <p class="btn-back margin-right-10">
                            <a class="router-link-active" href="" @click.prevent="$router.back()">Назад</a>
                        </p>

                        <p class="caption-help margin-right-10" v-if="report.new">Новый отчёт</p>
                        <p class="caption-help margin-right-10" v-if="!report.new">Статус: {{ report.StateFormatted }}</p>
                    </div>
                </div>
                <div class="control-block-right">
                    <div class="btns flex" data-toggle="buttons">
                        <!--
                        states:
                        NotApproved=1,
                        Approved = 2,
                        Edited = 3,
                        OnEdition = 4,
                        Cancelled = 5
                        -->
                        <template v-if="info.User && hasClaims(info.User.DynamicRole, claimEnums.reportAdd) && report.canBeEdited">
                            <span class="caption-help margin-right-10">
                                {{ EditingProcessState }}
                            </span>
                            <button type="button" class="btn btn-primary"
                                    @click="saveReport()"
                                    v-if="(report.new || report.State === 1 || report.State === 3 || report.State === 4) && !EditingProcessState">
                                Сохранить
                            </button>
                        </template>

                        <button type="button" class="btn btn-primary"
                                @click.stop="tryApproveReport()"
                                v-if="info.User && (hasClaims(info.User.DynamicRole, claimEnums.reportCheck) || info.User.MainRole === 'administrators')
                                    && (report.State === 1 || report.State === 3)">
                            Принять
                        </button>
                        <button type="button" class="btn btn-delete"
                                @click.stop="sendReportToEditionModal()"
                                v-if="info.User && (hasClaims(info.User.DynamicRole, claimEnums.reportCheck) || info.User.MainRole === 'administrators')
                                    && (report.State === 1 || report.State === 2 || report.State === 3)">
                            Доработать
                        </button>
                        <button type="button" class="btn btn-delete"
                                @click.stop="rejectReportModal()"
                                v-if="info.User && (info.User.MainRole === 'administrators' || hasClaims(info.User.DynamicRole, claimEnums.reportCheck))">
                            Отклонить
                        </button>
                        <button type="button" class="btn btn-delete" @click="deleteReport()" v-if="!report.new && info.User && info.User.MainRole === 'administrators'">Удалить</button>
                    </div>
                </div>
            </div>

            <div class="body-panel-content body-panel-content-page">
                <div class="flex btns" v-if="info.User && hasClaims(info.User.DynamicRole, claimEnums.reportAdd)">
                    <input type="file" id="qrCodeDropFiles"
                           class="file-upload-zone-btn" accept=".jpg,.jpeg,.png" @change="onQrCodeChange($event)" />
                    <button type="button" class="btn btn-default" onclick="document.getElementById('qrCodeDropFiles').click()">
                        Загрузить QrCode
                    </button>

                    <input type="file" id="checkDropFiles"
                           class="file-upload-zone-btn" accept=".jpg,.jpeg,.png" @change="onCheckChange($event)" />
                    <button type="button" class="btn btn-default" :disabled="checkLoadBtnDisabled"
                            onclick="document.getElementById('checkDropFiles').click()">
                        Загрузить фото чека
                    </button>
                </div>

                <div class="row report-photo-field margin-top-20">
                        <div class="thumbnail-img-block">
                            <div class="thumbnail-img"
                                 v-for="(img, i) of report.Photos">
                                <a target="_blank" v-if="img.FileData">
                                    <img :src="img.FileData"/>
                                </a>
                                <a target="_blank" v-if="!img.FileData && img.FileName"
                                   :href="img.FileName" class="lightzoom" rel="group">
                                    <img :src="img.FileName"/>
                                </a>

                                <div class="thumbnail-img-delete" @click="removeImage(i)" v-if="report.canBeEdited"></div>
                         </div>
                    </div>
                </div>

                <div class="row margin-top-20" v-if="report.FnsDetails != null">
                    <span>
                        Проверка ФНС:
                        <template v-if="report.FnsDetails.LastUpdate">
                            {{ report.FnsDetails.LastUpdate | date-long }}
                        </template>
                        <template v-else>
                            Не выполнена
                        </template>
                    </span>
                    <div v-if="report.FnsDetails.FnsCheckMessage">
                        <span>Результат:</span>
                        <div>
                            {{report.FnsDetails.FnsCheckMessage}}
                        </div>
                    </div>

                    <!--Это для дебага, пользователю не нужно видеть инфу в таком виде-->
                    <div v-if="report.FnsDetails.FnsCheckResponse">
                        <span>Полный ответ:</span>
                        <div>
                            {{report.FnsDetails.FnsCheckResponse}}
                        </div>
                    </div>
                </div>
            </div>

            <popup-window ref="ppEditModal" :title="'Отправка на доработку'">
                <div class="form-group">
                    <label class="input-text-lbl">
                        Причина отправки на доработку
                        <span class="required" aria-required="true">*</span>
                    </label>
                    <textarea name="EditionComment" rows="10" style="height:150px;"
                              :class="['input-memo', { 'input-error': errors.has('EditionComment') }]"
                              v-model="report.EditionComment"
                              v-validate="'required'"></textarea>
                    <span class="field-validation-valid" v-if="errors.has('EditionComment')">Заполните поле</span>
                </div>
                <div class="btns flex margin-top-20" data-toggle="buttons">
                    <button type="button" class="btn btn-primary" @click.stop="sendReportToEdition()">Принять</button>
                    <button type="button" class="btn" @click.stop="closeModal('ppEditModal')">Отмена</button>
                </div>
            </popup-window>

            <popup-window ref="ppApproveModal" :title="'Принятие отчёта'">
                <div class="form-group">
                    <label class="input-text-lbl">
                        Причины изменения отчета
                        <span class="required" aria-required="true">*</span>
                    </label>
                    <textarea name="ModificationComment" rows="10" style="height:150px;"
                              :class="['input-memo', { 'input-error': errors.has('ModificationComment') }]"
                              v-model="report.ModificationComment"
                              v-validate="'required'"></textarea>
                    <span class="field-validation-valid" v-if="errors.has('ModificationComment')">Заполните поле</span>
                </div>
                <div class="btns flex margin-top-20" data-toggle="buttons">
                    <button type="button" class="btn btn-primary"
                            @click.stop="approveReport()"
                            :disabled="!report.ModificationComment || report.ModificationComment.length < 3">
                        Принять
                    </button>
                    <button type="button" class="btn" @click.stop="closeModal('ppApproveModal')">Отмена</button>
                </div>
            </popup-window>

            <popup-window ref="ppRejectModal" :title="'Отклонение отчёта'">
                <div class="form-group">
                    <label class="input-text-lbl">
                        Укажите причину отклонения
                        <span class="required" aria-required="true">*</span>
                    </label>
                    <textarea name="CancellationComment" rows="10" style="height:150px;"
                              :class="['input-memo', { 'input-error': errors.has('CancellationComment') }]"
                              v-model="report.CancellationComment"
                              v-validate="'required'"></textarea>
                    <span class="field-validation-valid" v-if="errors.has('CancellationComment')">Заполните поле</span>
                    <span class="field-validation-valid"></span>
                </div>
                <div class="btns flex margin-top-20" data-toggle="buttons">
                    <button type="button" class="btn btn-primary"
                            @click="rejectReport()"
                            :disabled="!report.CancellationComment || report.CancellationComment.length < 3">Отклонить</button>
                    <button type="button" class="btn" @click="closeModal('ppRejectModal')">Отмена</button>
                </div>
            </popup-window>
        </template>

        <vue-headful :title="getPageTitle()" />
    </div>
</template>

<script>
    import $ from 'jquery'
    import _ from 'lodash'
    import BackendApi from '../../backendApi'
    import UI from '../../helpers/ui-helpers'
    import moment from 'moment'
    import config from '../../config'
    import projectMixin from '../../helpers/project-mixin'
    import {ReportPhotoTypes} from '../../enums'
    import imgMixin from '../../helpers/img-mixin'

    let backendApi = new BackendApi();

    export default {
        name: "Fns-Report-Edit",

        mixins: [projectMixin, imgMixin],

        props: ['info'],

        data() {
            return {
                report: null,
                origin: null,
                reportSettings: null,
                importResult: null,
                ReportExcelEnabled: false,

                numberOfLoads: 0,
                qrCodeLoadingSucceeded: false,
            }
        },

        computed:{
            EditingProcessState(){
                if(this.checkLoadBtnDisabled){
                    return 'Загрузите QR код';
                }
                if(!this.report.Photos.filter(x => x.TypeId === ReportPhotoTypes.Check).length)
                return 'Загрузите фото чека';
            },

            checkLoadBtnDisabled(){
                return !this.qrCodeLoadingSucceeded && this.numberOfLoads < 3;
            },

            // checkLoaded(){
            //     return this.report.Photos.filter(x => x.TypeId === ReportPhotoTypes.Check).length;
            // }
        },

        methods: {
            onCheckChange($event){
                let vm = this;

                let files = $event.target.files;
                if (files.length > 0) {
                    if (files.length > 1) {
                        UI.toastr.error('Выберите 1 файл');
                        return;
                    }

                    let reader = new FileReader();
                    reader.onload = function (e) {
                        vm.report.Photos.push({
                            FileData: e.target.result,
                            FileName: files[0].name,
                            TypeId: ReportPhotoTypes.Check
                        });
                    };
                    reader.readAsDataURL(files[0]);
                }
            },

            onQrCodeChange($event) {
                let vm = this;

                let files = $event.target.files;
                if (files.length > 0) {
                    if(files.length > 1){
                        UI.toastr.error('Выберите 1 файл');
                        return;
                    }
                    //if (window.FormData !== undefined) {
                        // let data = new FormData();
                        // data.append("file", files[0]);

                        let reader = new FileReader();
                        reader.onload = function (e) {
                            vm.callApiWrapper(backendApi.qrCodeImport({
                                Data:e.target.result,
                                FileName: files[0].name
                            })).then(function (response) {
                                if (response.hasError) {
                                    UI.toastr.error('Ошибка загрузки!');
                                }
                                else {
                                    if (response.data) {
                                        //console.info('response.data', response.data);
                                        vm.report.Photos = [];

                                        if(response.data){
                                            vm.report.Photos.push({
                                                FileData: e.target.result,
                                                FileName: files[0].name,
                                                TypeId: ReportPhotoTypes.QrCode
                                            })
                                            vm.qrCodeLoadingSucceeded = true;
                                        }else{
                                            vm.qrCodeLoadingSucceeded = false;
                                            vm.numberOfLoads++;
                                            if(vm.numberOfLoads > 2){
                                                UI.toastr.error('QR код не распознан. Попробуйте еще раз или загрузите чек');
                                            }else{
                                                UI.toastr.error('QR код не распознан, попробуйте еще раз');
                                            }
                                        }
                                    }
                                }
                                document.getElementById('qrCodeDropFiles').value = '';
                            });
                        };
                        reader.readAsDataURL(files[0]);

                    // } else {
                    //     UI.toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                    // }
                }
            },

            loadReport(){
                let vm = this;
                let id = parseInt(this.$route.params.id);

                return this.callApiWrapper(backendApi.reportLoad(id, vm.projectId)).then(function (response) {
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при загрузке отчета');
                    } else {
                        if (response.data) {
                            if (id === 0) {
                                vm.report = {
                                    new: true,
                                    Photos: [],
                                    ProjectId: vm.projectId,
                                    canBeEdited: true,
                                    ReportDateFormatted: null
                                };
                            }else{
                                vm.report = response.data.report;

                                if (vm.info && vm.info.User) {
                                    // продавцы могут редактировать новый отчет, доработанный или на доработке
                                    if (((vm.report.State === 1 || vm.report.State === 4 || vm.report.State === 3) && vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.reportAdd)) ||
                                        ((vm.report.State === 1 || vm.report.State === 3) && (vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.reportCheck) || vm.info.User.MainRole === 'administrators'))) {
                                        vm.report.canBeEdited = true;
                                    }
                                    else {
                                        vm.report.canBeEdited = false;
                                    }
                                }
                                vm.origin = JSON.parse(JSON.stringify(response.data.report));
                            }

                            vm.reportSettings = response.data.reportSettings;
                            vm.ReportExcelEnabled = response.data.ReportExcelEnabled;
                        }
                    }
                })
            },

            saveReport() {
                let vm = this;

                UI.blockUI('.dataContent', 'Сохранение...');

                backendApi.reportSave(vm.report).then(function (response) {
                    console.info('details -> reportSave, response:', response.data);
                    UI.unblockUI('.dataContent');

                    if (response.hasError) {
                        UI.toastr.error('Ошибка при сохранении отчета');
                    } else {
                        UI.toastr.success('Успешно сохранено');
                        vm.$router.push('/reports');
                    }
                });
            },

            //показываем окно с вводом комментария
            sendReportToEditionModal() {
                let vm = this;
                vm.$nextTick(() => {

                    vm.report.EditionComment = '';
                    vm.$refs.ppEditModal.show();

                });
            },

            // отправка на доработку
            sendReportToEdition() {
                if (!this.report.EditionComment) {
                    return;
                }

                this.report.State = 4;
                this.saveReport();
                this.$refs['ppEditModal'].close();
            },

            isReportChanged() {
                return JSON.stringify(this.report) !== JSON.stringify(this.origin);
            },

            // принятие отчёта
            tryApproveReport() {
                let vm = this;

                // проверяем что ничего в отчёте не менялось контролёром
                // если поменялось - показываем окно с комментарием
                if (this.isReportChanged()) {
                    vm.$nextTick(() => {
                        vm.$refs.ppApproveModal.show();
                    });
                }
                else {
                    this.report.State = 2;
                    this.report.ModificationComment = '';
                    this.saveReport();
                }
            },

            approveReport() {

                if (!this.report.ModificationComment) {
                    return;
                }

                this.report.State = 2;
                this.saveReport();
                this.$refs['ppApproveModal'].close();
            },

            rejectReportModal() {
                let vm = this;
                vm.$nextTick(() => {

                    vm.$refs.ppRejectModal.show();

                });
            },

            rejectReport() {
                if (!this.report.CancellationComment) {
                    return;
                }

                this.report.State = 5;
                this.saveReport();
            },

            deleteReport() {
                if (confirm('Вы уверены, что хотите удалить отчет?')) {
                    if(confirm('Отчет будет удален безвозвратно! Подтвердите действие!')) {
                        let vm = this;
                        UI.blockUI('.dataContent', 'Удаление...');

                        backendApi.reportDelete(vm.report.Id).then(function (response) {
                            UI.unblockUI('.dataContent');
                            if (response.hasError) {
                                UI.toastr.error('Ошибка при удалении отчета');
                            } else {
                                UI.toastr.success('Успешно удалено');
                                vm.$router.push('/reports');
                            }
                        });
                    }
                }
            },

            removeImage(i) {
                if (confirm('Удалить изображение?')) {
                    let k = 0;
                    for(let x of this.report.Photos){
                        if(k === i){
                            break;
                        }
                    }
                    this.report.Photos.splice(k, 1);
                }
            },
        },

        mounted() {
            let vm = this;

            UI.blockUI('.dataContent', 'Загрузка...');
            vm.loadReport().then(() => {
                UI.unblockUI('.dataContent');

                $('.lightzoom').fancybox({
                    beforeShow: function() {
                        let downloadpath = $.fancybox.wrap.find('.fancybox-image').attr('src');
                        let $btn = $('<a href="' + downloadpath + '" class="btn" download>Скачать</a>');
                        let $div = $(`<div class="btns flex">
<button type="button" class="btn btn-primary margin-top-15 zoom-plus btn-img"><img src="/Content/dist/icon-plus-2.png" alt=""></button>
<button type="button" class="btn btn-primary margin-top-15 zoom-minus btn-img"><img src="/Content/dist/icon-minus-2.png" alt=""></button>
</div>`);
                        $.fancybox.wrap.find('.fancybox-outer').after($btn);
                        $.fancybox.wrap.find('.fancybox-outer').before($div);
                        $.fancybox.wrap.find('img.fancybox-image').draggable();
                    }
                });
//
//                 $(document).on('click', '.zoom-plus', function(){
//                     vm.zoomIn();
//                 });
//                 $(document).on('click', '.zoom-minus', function(){
//                     vm.zoomOut();
//                 });
//
//                 $(window).bind('mousewheel DOMMouseScroll', function(event){
//                     if($.fancybox.wrap != null){
//                         if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
//                             vm.zoomOut();
//                         }
//                         else {
//                             vm.zoomIn();
//                         }
//                     }
//                 });
            })
        },

        destroyed(){
            // $(window).unbind('mousewheel DOMMouseScroll');
            // $(document).off('click', '.zoom-plus');
            // $(document).off('click', '.zoom-minus');
        }
    }
</script>

<style scoped>
    button.img-download{
        left: 50%;
        position: relative;
        margin-left: -35px;
    }
    .fancybox-inner {overflow: hidden !important;}
    .fancybox-nav{width: 40px !important;}
</style>


// WEBPACK FOOTER //
// Content/src/views/edit/FnsReportEdit.vue